// import React from 'react';
// import { Card, CardHeader, Heading, CardBody, Flex, Box, useColorMode } from '@chakra-ui/react';
// import ReactApexChart from 'react-apexcharts';

// const SalesVsPurchaseChart = ({ data, title = 'Sales vs Purchase', height = 400, minHeight = 400 }) => {
//    const { colorMode } = useColorMode();
//    const salesItem = data.find((item) => item.heading.toLowerCase() === 'sales');
//    const purchaseItem = data.find((item) => item.heading.toLowerCase() === 'purchase');

//    const salesAmount = salesItem?.amt || 0;
//    const purchaseAmount = purchaseItem?.amt || 0;
//    const totalAmount = salesAmount + purchaseAmount;

//    const options = {
//       chart: {
//          type: 'bar',
//          toolbar: { show: false },
//          background: 'transparent',
//       },
//       plotOptions: {
//          bar: {
//             horizontal: false,
//             columnWidth: '50%',
//             borderRadius: 4,
//          },
//       },
//       dataLabels: {
//          enabled: false,
//       },
//       xaxis: {
//          categories: ['Sales vs Purchase'],
//          labels: {
//             style: {
//                colors: colorMode === 'dark' ? '#E2E8F0' : '#4A5568',
//             },
//          },
//          title: {
//             text: 'Category',
//             style: {
//                color: colorMode === 'dark' ? '#E2E8F0' : '#4A5568',
//             },
//          },
//          axisBorder: {
//             show: true,
//             color: colorMode === 'dark' ? '#4A5568' : '#E2E8F0',
//          },
//          axisTicks: {
//             show: true,
//             color: colorMode === 'dark' ? '#4A5568' : '#E2E8F0',
//          },
//       },
//       yaxis: {
//          title: {
//             text: 'Amount (₹)',
//             style: {
//                color: colorMode === 'dark' ? '#E2E8F0' : '#4A5568',
//             },
//          },
//          labels: {
//             style: {
//                colors: colorMode === 'dark' ? '#E2E8F0' : '#4A5568',
//             },
//             formatter: (val) => '₹' + val.toLocaleString('en-IN'),
//          },
//       },
//       tooltip: {
//          theme: colorMode,
//          y: {
//             formatter: (val) => '₹' + val.toLocaleString('en-IN'),
//          },
//       },
//       colors: colorMode === 'dark' ? ['#68D391', '#4299E1'] : ['#38A169', '#3182CE'], // green for sales, blue for purchase
//       grid: {
//          borderColor: colorMode === 'dark' ? '#4A5568' : '#E2E8F0',
//       },
//       legend: {
//          labels: {
//             colors: colorMode === 'dark' ? '#E2E8F0' : '#4A5568',
//          },
//       },
//    };

//    const series = [
//       {
//          name: 'Sales',
//          data: [salesAmount],
//       },
//       {
//          name: 'Purchase',
//          data: [purchaseAmount],
//       },
//    ];

//    return (
//       <Card h={height} minH={minHeight} bg={colorMode === 'dark' ? 'gray.700' : 'white'}>
//          <CardHeader>
//             <Heading size="md">
//                <Flex direction="column" alignItems="start" justifyContent="center">
//                   <Box color={colorMode === 'dark' ? 'teal.300' : 'teal.600'}>{title}</Box>
//                   <Box fontWeight="normal" fontSize="18px" color={colorMode === 'dark' ? 'gray.300' : 'gray.600'}>
//                      ₹ {totalAmount.toLocaleString('en-IN')}
//                   </Box>
//                </Flex>
//             </Heading>
//          </CardHeader>
//          <CardBody>
//             <ReactApexChart options={options} series={series} type="bar" height={height - 100} />
//          </CardBody>
//       </Card>
//    );
// };

// export default SalesVsPurchaseChart;

import React, { useState } from 'react';
import { Card, CardHeader, Heading, CardBody, Flex, Box, useColorMode } from '@chakra-ui/react';
import ReactApexChart from 'react-apexcharts';
import { RotateCw } from 'lucide-react';
import { useDispatch } from 'react-redux';
import { getTotalSalesAndPurchases } from '../../../../redux/actions/dashboard';

const SalesVsPurchaseChart = ({ data, title = 'Sales vs Purchase', height = 300, minHeight = 300, financialAnalysisDateRange, user }) => {
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';
   const salesItem = data.find((item) => item.heading.toLowerCase() === 'sales');
   const purchaseItem = data.find((item) => item.heading.toLowerCase() === 'purchase');
   const [isRotating, setIsRotating] = useState(false);
   const dispatch = useDispatch();

   const salesAmount = salesItem?.amt || 0;
   const purchaseAmount = purchaseItem?.amt || 0;
   const totalAmount = salesAmount + purchaseAmount;

   const options = {
      chart: {
         type: 'radialBar',
         toolbar: { show: true },
      },
      plotOptions: {
         radialBar: {
            dataLabels: {
               name: {
                  fontSize: '16px',
                  color: colorMode === 'dark' ? '#E2E8F0' : '#4A5568',
               },
               value: {
                  fontSize: '24px',
                  color: colorMode === 'dark' ? '#E2E8F0' : '#4A5568',
                  formatter: function (val) {
                     return '₹' + Math.round((val / 100) * totalAmount).toLocaleString('en-IN');
                  },
               },
               total: {
                  show: true,
                  label: 'Total',
                  color: colorMode === 'dark' ? '#E2E8F0' : '#4A5568',
                  formatter: function (w) {
                     return '₹' + totalAmount.toLocaleString('en-IN');
                  },
               },
            },
         },
      },
      labels: ['Sales', 'Purchase'],
      colors: colorMode === 'dark' ? ['#68D391', '#4299E1'] : ['#249791ff', '#10518dff'],
   };

   const series = [(salesAmount / totalAmount) * 100, (purchaseAmount / totalAmount) * 100];

   const handleReload = async () => {
      setIsRotating(true);
      dispatch(
         getTotalSalesAndPurchases({
            companyId: user?.loginhistory?.companyId,
            fromDate: financialAnalysisDateRange.fromDate,
            toDate: financialAnalysisDateRange.toDate,
         }),
      );
      setTimeout(() => setIsRotating(false), 700);
   };

   return (
      <div
         className={`rounded-lg shadow-md ${isDark ? 'bg-gray-700' : 'bg-white'}`}
         style={{
            height: typeof height === 'number' ? `${height}px` : height,
            minHeight: typeof minHeight === 'number' ? `${minHeight}px` : minHeight,
         }}>
         <div className="flex px-6 py-4 border-b border-gray-200 dark:border-gray-600">
            <div className="flex flex-col items-start justify-center">
               <div className="flex items-center gap-3">
                  <div className={`w-1 h-8 rounded-full ${isDark ? 'bg-teal-300' : 'bg-teal-600'}`}></div>
                  <div>
                     <div className={`text-xl font-bold ${isDark ? 'text-white' : 'text-black'}`}>{title}</div>
                  </div>
               </div>
               <div className={`text-lg font-normal mt-1 ${isDark ? 'text-gray-300' : 'text-gray-600'}`}>
                  ₹ {totalAmount.toLocaleString('en-IN')}
               </div>
            </div>
            <button
               onClick={handleReload}
               className={`ml-auto p-2 rounded-full transition-all hover:scale-110 ${isDark ? "hover:bg-gray-600 text-blue-400" : "hover:bg-gray-100 text-blue-600"
                  }`}
            >
               <RotateCw
                  className={`w-5 h-5 transform ${isRotating ? "rotate-[360deg]" : ""
                     } transition-transform ease-in-out`}
                  style={{
                     transitionDuration: isRotating ? "700ms" : "10ms",
                  }}
               />
            </button>
         </div>
         <div className="p-6">
            <ReactApexChart options={options} series={series} type="donut" height={'220%'} />
         </div>
      </div>
   );
};

export default SalesVsPurchaseChart;
